import * as THREE from 'three';
/** Three slender blades follow curved centerlines. Five triangles per blade. */
export function grassTuftGeometry(){
 const positions=[],normals=[];
 for(let j=0;j<3;j++){
  const angle=j*2.399,height=[.17,.132,.105][j],width=[.0032,.0028,.0025][j],lean=[.044,.052,.039][j],ca=Math.cos(angle),sa=Math.sin(angle),side=new THREE.Vector3(ca,0,sa),forward=new THREE.Vector3(-sa,0,ca),points=[],vertexNormals=[];
  for(const[t,across]of[[0,-1],[0,1],[.38,-.91],[.38,.91],[.74,-.52],[.74,.52],[1,0]]){
   const p=side.clone().multiplyScalar(across*width*.5).addScaledVector(forward,(t*t*.72+t*t*t*.28)*lean);p.y=t*height;points.push(p);
   // Smooth convex cross-section normals retain a thin highlight, rather than
   // forcing every blade to share an upward-facing flat sheet normal.
   const tangent=new THREE.Vector3(forward.x*lean*(1.44*t+.84*t*t),height,forward.z*lean*(1.44*t+.84*t*t));
   const n=new THREE.Vector3().crossVectors(side,tangent).normalize().addScaledVector(side,across*.20).normalize();vertexNormals.push(n);
  }
  for(const f of[[0,1,2],[1,3,2],[2,3,4],[3,5,4],[4,5,6]])for(const i of f){positions.push(...points[i].toArray());normals.push(...vertexNormals[i].toArray());}
 }
 const g=new THREE.BufferGeometry();g.setAttribute('position',new THREE.Float32BufferAttribute(positions,3));g.setAttribute('normal',new THREE.Float32BufferAttribute(normals,3));g.computeBoundingBox();return g;
}
